import { BaseEntity } from './base';

export class TruckModel extends BaseEntity {
  name?: string;
}



// WEBPACK FOOTER //
// ./src/models/truck.ts